import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { CheckCircle2, Mail, Clock, ArrowRight } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_ab04b277-779a-46f6-a15c-41b90e7d7254/artifacts/ccdpbqku_TBP-New%20Logo%20Design%20conv%201.png";

export default function ApplicationConfirmation() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex flex-col" data-testid="application-confirmation">
      {/* Header */}
      <header className="bg-white shadow-sm">
        <div className="max-w-3xl mx-auto px-4 py-4">
          <Link to="/" className="flex items-center gap-2">
            <img src={LOGO_URL} alt="The Bookshelf Project" className="h-10 w-auto" />
          </Link>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-4">
        <Card className="max-w-lg w-full border-0 shadow-xl">
          <CardContent className="p-8 text-center space-y-6">
            <div className="w-20 h-20 bg-emerald-100 rounded-full flex items-center justify-center mx-auto">
              <CheckCircle2 className="w-12 h-12 text-emerald-600" />
            </div>

            <div>
              <h1 className="text-3xl font-bold text-[#1a3a5c] mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Application Received!
              </h1>
              <p className="text-slate-600">
                Thank you for applying to volunteer with The Bookshelf Project.
              </p>
            </div>

            <div className="bg-slate-50 rounded-xl p-6 text-left space-y-4">
              <div className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#5cc8e8] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-[#1a3a5c]">Confirmation Email Sent</p>
                  <p className="text-sm text-slate-500">Check your inbox for a confirmation email with next steps.</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Clock className="w-5 h-5 text-[#5cc8e8] flex-shrink-0 mt-0.5" />
                <div>
                  <p className="font-medium text-[#1a3a5c]">What's Next?</p>
                  <p className="text-sm text-slate-500">Our team will review your application and contact you within 5-7 business days with next steps.</p>
                </div>
              </div>
            </div>

            <div className="pt-4 space-y-3">
              <Link to="/">
                <Button className="w-full bg-[#1a3a5c] hover:bg-[#1a3a5c]/90 text-white rounded-full py-6" data-testid="return-home-btn">
                  Return to Home
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>

            <p className="text-sm text-slate-500">
              Questions? Contact us at{' '}
              <a href="mailto:info@thebookshelfproject.org" className="text-[#5cc8e8] hover:underline">
                info@thebookshelfproject.org
              </a>
            </p>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
